import React, { Fragment } from 'react';
import { Portal } from 'react-portal';
import { useDispatch } from "react-redux"
import { setIsOpen as setIsMobileOpen } from '../Actions/Navigation.action'
import { translate } from "../Services/translation"

const NavigationMobile = props => {
    const { logoUrl, startPageUrl, open } = props
    const links = [...props.contentLinks, ...props.rightContentLinks, ...props.topMenu.leftLinks, ...props.topMenu.rightLinks]

    const [currentLink, setCurrentLink] = React.useState()
    const ref = React.createRef()
    const dispatch = useDispatch()

    const close = () => {
        dispatch(setIsMobileOpen(false))
    }

    const hasChildren = link => link.links && link.links.length > 0

    const getLinks = () => {
        let _links = currentLink ? currentLink.links : links
        return _links.map(link => 
            <div className={"navbar-mobile__item" + (hasChildren(link) ? " navbar-mobile__link--has-children" : "")} key={link.name+link.url}>
                <a href={link.url} className="navbar-mobile__link"><h6>{link.name || link.title}</h6></a>
                {hasChildren(link) &&
                    <div className="navbar-mobile__item-child-link" onClick={e => showChildLinks(e, link)}>
                        <i className="icon icon-chevron-right"></i>
                    </div>
                }
            </div>
        )
    }

    const showChildLinks = (e, link) => {
        e.preventDefault()
        var linkCopy = link
        if(currentLink)
            linkCopy.parent = currentLink
        setCurrentLink(linkCopy)
    }

    const goToParentLink = () => {
        if(currentLink && currentLink.parent)
            setCurrentLink(currentLink.parent)
        else
            setCurrentLink(undefined)
    }

    React.useEffect(() => {
        if(open) {
            document.body.classList.add("dark-overlay", "no-scroll")
        }else{
            document.body.classList.remove("dark-overlay", "no-scroll")
        }
    }, [open])

    return <Portal node={document && document.body}>
        <div className={"navbar-mobile" + (open ? " navbar-mobile--open" : "")} ref={ref}>
            <button className="navbar-mobile__close-btn" onClick={close} aria-label="Close mobile menu"><i className="icon icon-cancel"></i></button>
            <div className="navbar-mobile__wrapper">
                <div className="navbar-mobile__header">
                    {!currentLink && <h3>{translate("navbar.menu")}</h3>}
                    {currentLink && <a className="navbar-mobile__back" onClick={goToParentLink}><i className="icon icon-chevron-left"></i> {translate("navbar.back")}</a>}
                </div>
                <div className="navbar-mobile__links">
                    {getLinks()}
                </div>
            </div>
        </div>
    </Portal>
}

export default NavigationMobile;